import components from "./components";

export default {
    items: [
        {
            title: 'Home',
            icon: 'mdi-home',
            path: '/docs',
            items: []
        },
        {
            title: 'Roadmap',
            icon: 'mdi-road-variant',
            path: '/docs/roadmap',
            items: []
        },
        {
            title: 'Demonstração',
            icon: 'mdi-card-bulleted-settings-outline',
            path: '/sample',
            target: '_blank',
            separator: true,
            items: []
        },
        // {
        //     title: 'Código Fonte',
        //     icon: 'mdi-source-branch',
        //     path: '/docs/source-code',
        //     separator: true,
        //     items: []
        // },
        {
            title: 'Introdução',
            icon: 'mdi-clipboard-text-outline',
            type: 'menu',
            path: null,
            items: [
                {
                    title: 'Estrutura de Pastas',
                    icon: null,
                    path: '/docs/structure',
                    items: []
                },
                {
                    title: 'Paleta de Cores',
                    icon: null,
                    path: '/docs/themes',
                    items: []
                },
                {
                    title: 'Internacionalização',
                    icon: null,
                    path: '/docs/i18n',
                    items: []
                },
                {
                    title: 'Utilitários',
                    icon: null,
                    path: '/docs/utilities',
                    items: []
                },
                {
                    title: 'Componentes',
                    icon: null,
                    type: 'submenu',
                    path: null,
                    items: components.map(item => {
                        return {
                            title: item.name,
                            path: item.path,
                            visible: item.status >= 100,
                            icon: null,
                            items: []
                        };
                    }).filter(item => {
                        if (item.visible) {
                            return item;
                        }
                    }),
                    // items: [
                    //     {
                    //         title: 'Authenticator',
                    //         icon: null,
                    //         path: '/docs/components/authenticator',
                    //         items: []
                    //     },
                    //     {
                    //         title: 'NavBar',
                    //         icon: null,
                    //         path: '/docs/components/navbar',
                    //         items: []
                    //     },
                    // ]
                },
            ]
        }
    ],
};
